// 日历卡片尺寸，不同的尺寸对应不同的宽度
export enum CalendarCardSize {
  // 超小
  XS = 1,
  // 小
  S = 2,
  // 中
  M = 3,
  // 大
  L = 4,
  // 超大
  XL = 5,
}

// currentBtn按钮箭头类型
export enum CalendarCurrentBtnArrowType {
  // 箭头隐藏
  Hidden = 0,
  // 箭头向左
  Left = -1,
  // 箭头向右
  Right = 1,
  // 箭头双向
  Double,
}
